<template>
  <div>
    <Header />
    <div
      class="container mx-auto max-w-[1200px] w-full py-3 flex flex-col gap-10 px-4 md:px-6 lg:gap-2"
    >
      <div class="flex justify-end">
        <router-link
          :to="{ name: 'InstructorHome' }"
          class="bg-blues hover:bg-hover text-white rounded-2xl text-sm font-semibold px-4 py-1"
          >Back</router-link
        >
      </div>

      <SyallbusView />
    </div>
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import SyallbusView from "@/components/SyallbusView.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    Header,
    SyallbusView,
  },
  computed: mapGetters(["userInfo"]),
};
</script>

<style></style>
